import { render, staticRenderFns } from "./ReviewDocumentsModal.vue?vue&type=template&id=7c6b85c8&scoped=true&"
import script from "./ReviewDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./ReviewDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDocumentsModal.vue?vue&type=style&index=0&id=7c6b85c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6b85c8",
  null
  
)

export default component.exports